import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import routes from '../../../config/routes'
// Landing components
import LandingPage from '../../pages/LandingPage/LandingPage'

// Login components
import LoginPage from '../../pages/Login/LoginContainer'
import LoginBlocked from '../../pages/LoginBlockedFeedback/LoginBlockedFeedbackContainer'
import LoginAuth from '../../pages/LoginAuth/LoginAuthContainer'

// Register components
import RegisterCNPJ from '../../pages/RegisterCNPJ/RegisterCNPJContainer'
import RegisterEmail from '../../pages/RegisterEmail/RegisterEmailContainer'
import RegisterPhone from '../../pages/RegisterPhone/RegisterPhoneContainer'
import RegisterPassword from '../../pages/RegisterPassword/RegisterPasswordContainer'

// Register Confirm components
import ConfirmRegisterPhone from '../../pages/ConfirmRegisterPhone/ConfirmRegisterPhoneContainer'
import ConfirmRegisterEmail from '../../pages/ConfirmRegisterEmail/ConfirmRegisterEmailContainer'
import ConfirmRegisterEmailReceive from '../../pages/ConfirmRegisterEmailReceive/ConfirmRegisterEmailReceiveContainer'
import ConfirmRegisterEmailSuccessContainer from '../../pages/ConfirmRegisterEmailSuccess/ConfirmRegisterEmailSuccessContainer'
import ConfirmRegisterEmailFailContainer from '../../pages/ConfirmRegisterEmailFail/ConfirmRegisterEmailFailContainer'

import RegisterSuccessfulFeedback from '../../pages/RegisterSuccessfulFeedback/RegisterSuccessfulFeedbackContainer'

import RegisterAlterEmail from '../../pages/RegisterAlterEmail/RegisterEmailContainer'

// Terms components
import Term from '../../pages/Terms/TermsContainer'
import TermInternal from '../../pages/TermsInternal/TermsInternal'
import TermRefuseFeedback from '../../pages/TermsRefuseFeedback/TermsRefuseFeedbackContainer'

// Recovery Password components
import RecoveryPasswordSentEmail from '../../pages/RecoveryPasswordSentEmail/RecoveryPasswordSentEmailContainer'
import RecoveryPasswordSentEmailFeedback from '../../pages/RecoveryPasswordSentEmailFeedback/RecoveryPasswordSentEmailFeedbackContainer'
import RecoveryPasswordResentEmailFeedback from '../../pages/RecoveryPasswordResentEmailFeedback/RecoveryPasswordResentEmailFeedbackContainer'
import RecoveryPasswordSentPassword from '../../pages/RecoveryPasswordSentPassword/RecoveryPasswordSentPasswordContainer'
import RecoveryPasswordAuth from '../../pages/RecoveryPasswordAuth/RecoveryPasswordAuthContainer'
import RecoveryPasswordFeedback from '../../pages/RecoveryPasswordFeedback/RecoveryPasswordFeedbackContainer'

// Wallet components
import Wallet from '../../pages/Wallet/WalletContainer'
import WalletSearch from '../../pages/WalletSearch/WalletSearchContainer'

// Extract components
import Extract from '../../pages/Extract/ExtractContainer'
import ExtractIndicatoresManagerial from '../../pages/ExtractIndicatorsManagerial/ExtractIndicatorsManagerial'
import ExtractDetailTwo from '../../pages/ExtractDetailTwo/ExtractDetailTwo'
import DetailStore from '../../pages/DetailStore/DetailStore'

import DetailProduct from '../../pages/DetailProduct/DetailProduct'
import Profile from '../../pages/Profile/ProfileContainer'
import ProfileStoreDetail from '../../pages/ProfileStoreDetail/ProfileStoreDetailContainer'
import ProfileDetail from '../../pages/ProfileDetail/ProfileDetailContainer'
import Page404 from '../../pages/Page404/Page404Container'
import Content from '../../pages/Content/ContentContainer'
import ContentDetail from '../../pages/ContentDetail/ContentDetailContainer'
import TempListRoutes from '../../pages/TempListRoutes/TempListRoutesContainer'
import ContentSearch from '../../pages/ContentSearch/ContentSearch'
import Timeline from '../../pages/Timeline/TimelineContainer'
import TimelineForm from '../../pages/TimelineForm/TimelineFormContainer'
import AwaitingApproval from '../../pages/AwaitingApproval/AwaitingApprovalContainer'

// People
import PeopleList from '../../pages/People/PeopleList'
import PeopleDetail from '../../pages/PeopleDetail/PeopleDetail'
import PeoplePersonalData from '../../pages/PeoplePersonalData/PeoplePersonalData'
import PeoplePersonCompany from '../../pages/PeoplePersonCompany/PeoplePersonCompany'

import Dashboard from '../../pages/Dashboard/Dashboard'
import DashboardMobile from '../../pages/DashboardMobile/DashboardMobile'

import RedirectToStores from '../../pages/RedirectToStores/RedirectToStores'

// import { detectMob } from '../../../utils/common'

const VerifyIsMobile = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />
}

VerifyIsMobile.defaultProps = {
  location: undefined
}

VerifyIsMobile.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.func
  ]).isRequired,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
}

const Routes = () => (
  <Switch>
    {/* Dashboard public */}
    <Route exact path="/dashboard-embed" component={DashboardMobile} />
    <Route exact path="/suggest-app" component={RedirectToStores} />

    {/* Landing page */}
    <VerifyIsMobile exact path={routes.root.path} component={LandingPage} />

    {/* Login routes  */}
    <VerifyIsMobile exact path={routes.login.path} component={LoginPage} />
    <VerifyIsMobile
      exact
      path={routes.loginBlocked.path}
      component={LoginBlocked}
    />
    <VerifyIsMobile exact path={routes.loginAuth.path} component={LoginAuth} />

    {/* Register routes */}
    <VerifyIsMobile
      exact
      path={routes.awaitingApproval.path}
      component={AwaitingApproval}
    />
    <VerifyIsMobile
      exact
      path={routes.registerCNPJ.path}
      component={RegisterCNPJ}
    />
    <VerifyIsMobile
      exact
      path={routes.registerEmail.path}
      component={RegisterEmail}
    />
    <VerifyIsMobile
      exact
      path={routes.registerPhone.path}
      component={RegisterPhone}
    />
    <VerifyIsMobile
      exact
      path={routes.registerPassword.path}
      component={RegisterPassword}
    />

    {/* Register Confirm routes */}
    <VerifyIsMobile
      exact
      path={routes.registerPhoneConfirm.path}
      component={ConfirmRegisterPhone}
    />
    <VerifyIsMobile
      exact
      path={routes.registerEmailConfirm.path}
      component={ConfirmRegisterEmail}
    />
    <VerifyIsMobile
      exact
      path={routes.registerEmailConfirmReceive.path}
      component={ConfirmRegisterEmailReceive}
    />
    <VerifyIsMobile
      exact
      path={routes.registerEmailConfirmSuccess.path}
      component={ConfirmRegisterEmailSuccessContainer}
    />
    <VerifyIsMobile
      exact
      path={routes.registerEmailConfirmFail.path}
      component={ConfirmRegisterEmailFailContainer}
    />

    <VerifyIsMobile
      exact
      path={routes.registerAlterEmail.path}
      component={RegisterAlterEmail}
    />

    <VerifyIsMobile
      exact
      path={routes.registerSuccessFeedback.path}
      component={RegisterSuccessfulFeedback}
    />

    {/* Terms routes */}
    <VerifyIsMobile exact path={routes.terms.path} component={Term} />
    <VerifyIsMobile
      exact
      path={routes.termsInternal.path}
      component={TermInternal}
    />
    <VerifyIsMobile
      exact
      path={routes.termsRefuse.path}
      component={TermRefuseFeedback}
    />

    {/* Recovery Password routes */}
    <VerifyIsMobile
      exact
      path={routes.resetPasswordSentEmail.path}
      component={RecoveryPasswordSentEmail}
    />
    <VerifyIsMobile
      exact
      path={routes.resetPasswordSentEmailFeedback.path}
      component={RecoveryPasswordSentEmailFeedback}
    />
    <VerifyIsMobile
      exact
      path={routes.resetPasswordResentEmailFeedback.path}
      component={RecoveryPasswordResentEmailFeedback}
    />
    <VerifyIsMobile
      exact
      path={routes.resetPasswordSentPassword.path}
      component={RecoveryPasswordSentPassword}
    />

    <VerifyIsMobile
      exact
      path={routes.firstAccess.path}
      component={RecoveryPasswordSentPassword}
    />

    <VerifyIsMobile
      exact
      path={routes.resetPasswordAuth.path}
      component={RecoveryPasswordAuth}
    />
    <VerifyIsMobile
      exact
      path={routes.resetPasswordSentPasswordFeedback.path}
      component={RecoveryPasswordFeedback}
    />
    <VerifyIsMobile
      exact
      path={routes.resetPasswordSuccessfully.path}
      component={RecoveryPasswordFeedback}
    />

    <VerifyIsMobile exact path={routes.dashboard.path} component={Dashboard} />
    <VerifyIsMobile exact path={routes.profile.path} component={Profile} />
    <VerifyIsMobile
      exact
      path={routes.profileDetail.path}
      component={ProfileDetail}
    />
    <VerifyIsMobile
      exact
      path={routes.profileStoreDetail.path}
      component={ProfileStoreDetail}
    />

    <VerifyIsMobile exact path={routes.wallet.path} component={Wallet} />
    <VerifyIsMobile path={routes.walletSearch.path} component={WalletSearch} />
    <VerifyIsMobile exact path={routes.extract.path} component={Extract} />
    <VerifyIsMobile
      exact
      path={routes.extractIndicatorsManagerial.path}
      component={ExtractIndicatoresManagerial}
    />
    <VerifyIsMobile
      exact
      path={routes.extractDetailTwo.path}
      component={ExtractDetailTwo}
    />
    <VerifyIsMobile
      exact
      path={routes.detailStore.path}
      component={DetailStore}
    />
    <VerifyIsMobile
      exact
      path={routes.detailProduct.path}
      component={DetailProduct}
    />

    <VerifyIsMobile exact path={routes.content.path} component={Content} />
    <VerifyIsMobile
      exact
      path={routes.contentSearch.path}
      component={ContentSearch}
    />
    <VerifyIsMobile
      exact
      path={routes.contentDetail.path}
      component={ContentDetail}
    />

    <VerifyIsMobile
      exact
      path={routes.routes.path}
      component={TempListRoutes}
    />

    <VerifyIsMobile
      exact
      path={routes.detailProduct.path}
      component={DetailProduct}
    />
    <VerifyIsMobile exact path={routes.timeline.path} component={Timeline} />
    <VerifyIsMobile
      exact
      path={routes.timelineForm.path}
      component={TimelineForm}
    />

    <VerifyIsMobile
      exact
      path={routes.people.list.path}
      component={PeopleList}
    />
    <VerifyIsMobile
      exact
      path={routes.people.personalData.path}
      component={PeoplePersonalData}
    />
    <VerifyIsMobile
      exact
      path={routes.people.company.path}
      component={PeoplePersonCompany}
    />
    <VerifyIsMobile
      extact
      path={routes.people.detail.path}
      component={PeopleDetail}
    />

    <VerifyIsMobile component={Page404} exact path="/404" />
    <Redirect to="/404" />
  </Switch>
)

export default Routes
